import { __makeTemplateObject } from "tslib";
import styled from "styled-components";
export var VerticalSpace = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  height: ", ";\n"], ["\n  height: ", ";\n"])), function (_a) {
    var _b = _a.size, size = _b === void 0 ? "10px" : _b;
    return size;
});
var templateObject_1;
